/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import Slider from 'components/Credit24/LoanApplication/OfferDetails/Slider';
import { fromCents, getCurrencyCode } from 'utils/helpers';

const propTypes = {
  maximumAmount: PropTypes.string.isRequired,
  availablePrincipalsIndex: PropTypes.array.isRequired,
  maturityPeriods: PropTypes.array.isRequired,
  productOffer: PropTypes.object.isRequired,
  currentPayout: PropTypes.string.isRequired,
  receivedAmount: PropTypes.string.isRequired,
  paymentInterval: PropTypes.string.isRequired,
};

const UpsellProduct = ({
  maximumAmount,
  availablePrincipalsIndex,
  maturityPeriods,
  productOffer: {
    repayment,
    monthsLoanDuration,
    establishmentFee,
    loanAmount,
    apr,
    annualInterest,
  },
  currentPayout,
  receivedAmount,
  paymentInterval,
}) => (
  <div className="loan-form__step">
    <h1 className="loan-form__step-title txt-center">
      <FormattedMessage id="upsell.offer.title" />
    </h1>
    <div className="loan-form__step-body">
      <div className="message message--offer">
        <div className="message__value">
          <FormattedNumber
            minimumFractionDigits={0}
            maximumFractionDigits={0}
            currency={getCurrencyCode()}
            style="currency"
            value={fromCents(maximumAmount)}
          />
        </div>
        <div className="message__content">
          <FormattedMessage id="upsell.offer.maximum" />
        </div>
      </div>
      <div className="offer-details">
        <div className="offer-details__item offer-details__item--large">
          <h3 className="txt-muted">
            <FormattedMessage id="upsell.offer.principalIndexSliderTitle" />
          </h3>
          <div className="padding-bottom--20">
            <Slider
              name="principalIndex"
              maxValue={availablePrincipalsIndex.length - 1}
              minValue={0}
              availablePrincipalsIndex={availablePrincipalsIndex}
              step={1}
              defaultValue={availablePrincipalsIndex.length - 1}
              productType="INSTALLMENT"
              asterisk
            />
          </div>
          <h3 className="txt-muted">
            <FormattedMessage id="upsell.offer.maturitySliderTitle" />
          </h3>
          <Slider
            name="selectedMaturity"
            minValue={0}
            maxValue={maturityPeriods.length - 1}
            availablePrincipalsIndex={maturityPeriods}
            step={1}
            defaultValue={
              Math.min(maturityPeriods.length - 1, maturityPeriods.indexOf(monthsLoanDuration))
            }
            productType="INSTALLMENT_maturity"
            theme="maturity"
          />
        </div>
        <div className="offer-details__item offer-details__item--small">
          <div className="offer-details__amount">
            <FormattedNumber
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              currency={getCurrencyCode()}
              style="currency"
              value={repayment}
            />
          </div>
          <div className="offer-details__label txt-muted padding-bottom--20">
            <FormattedMessage id={`offer.mmp.label.${paymentInterval}`} />
          </div>
          <div className="offer-details__label txt-muted">
            <FormattedMessage id="upsell.offer.apr" />
          </div>
          <div className="offer-details__amount padding-bottom--20">
            {apr}
            %
          </div>
          <div className="offer-details__label txt-muted">
            <FormattedMessage id="upsell.offer.annualInterest" />
          </div>
          <div className="offer-details__amount">
            {annualInterest}
            %
          </div>
        </div>
      </div>
      <h3>
        <FormattedMessage id="upsell.offer.financialInformationTitle" />
      </h3>
      <table className="table table--offer-page-simple">
        <tbody>
          <tr>
            <td>
              <FormattedMessage id={`upsell.offer.repayment.${paymentInterval}`} />
            </td>
            <td>
              <FormattedNumber
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                currency={getCurrencyCode()}
                style="currency"
                value={repayment}
              />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="upsell.offer.newLoanTerm" />
            </td>
            <td>
              <FormattedMessage id={`date.months.${monthsLoanDuration}`} />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="upsell.offer.newLoanAmount" />
            </td>
            <td>
              <FormattedNumber
                minimumFractionDigits={0}
                maximumFractionDigits={0}
                currency={getCurrencyCode()}
                style="currency"
                value={fromCents(loanAmount)}
              />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="upsell.offer.loanPayout" />
            </td>
            <td>
              <FormattedNumber
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                currency={getCurrencyCode()}
                style="currency"
                value={fromCents(currentPayout)}
              />
            </td>
          </tr>
          <tr>
            <td>
              <FormattedMessage id="upsell.offer.establishmentFee" />
            </td>
            <td>
              <FormattedNumber
                minimumFractionDigits={0}
                maximumFractionDigits={0}
                currency={getCurrencyCode()}
                style="currency"
                value={fromCents(establishmentFee)}
              />
            </td>
          </tr>
          <tr className="txt-larger txt-bold">
            <td>
              <FormattedMessage id="upsell.offer.amountReceived" />
            </td>
            <td>
              <FormattedNumber
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                currency={getCurrencyCode()}
                style="currency"
                value={fromCents(receivedAmount)}
              />
              <span>*</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p className="upsell-disclamer">
        <FormattedMessage id="upsell.offer.disclaimer" />
      </p>
    </div>
  </div>
);

UpsellProduct.propTypes = propTypes;

export default UpsellProduct;
